import { getAuthenticatedClient } from '../supabase/authenticatedClient';

export const getCategories = async () => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client.from('categories').select('*').order('name');

  if (error) {
    throw error;
  }

  return data;
};

export const createCategory = async categoryData => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client.from('categories').insert([categoryData]).select().single();

  if (error) {
    throw error;
  }

  return data;
};

export const updateCategory = async (id, categoryData) => {
  const client = await getAuthenticatedClient();
  const { data, error } = await client
    .from('categories')
    .upsert({ ...categoryData, id })
    .select()
    .single();

  if (error) {
    throw error;
  }

  return data;
};

export const deleteCategory = async id => {
  const client = await getAuthenticatedClient();
  const { error } = await client.from('categories').delete().eq('id', id);

  if (error) {
    throw error;
  }
};
